import React from 'react';
import { faFileInvoiceDollar } from '@fortawesome/pro-regular-svg-icons/faFileInvoiceDollar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function FileInvoiceDollarRegularIcon(
  props: React.PropsWithChildren<React.HTMLAttributes<SVGElement>>
) {
  return <FontAwesomeIcon icon={faFileInvoiceDollar} {...props} />;
}
